import { isEmpty } from 'lodash';
import moment from 'moment';

import { Session } from '../../legacy/types';

const getSessionsWithin48Hours = ({
  enrolmentId,
  sessions,
  timezone,
}: {
  enrolmentId: string;
  sessions: Array<Session>;
  timezone: string;
}): Array<Session> => {
  if (!enrolmentId || isEmpty(sessions)) {
    return [];
  }

  return sessions.filter((s) => {
    const { uniqueEnrolmentId, startTime } = s;
    const today = moment.tz(timezone).startOf('day');
    const theNext2Days = moment.tz(timezone).startOf('day').add(2, 'days');
    const sessionTime = moment.utc(startTime).tz(timezone);
    return (
      uniqueEnrolmentId === enrolmentId &&
      sessionTime.isSameOrAfter(today, 'day') &&
      sessionTime.isSameOrBefore(theNext2Days, 'day')
    );
  });
};

export default getSessionsWithin48Hours;
